
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { objectWithoutProperties as _objectWithoutProperties, slicedToArray as _slicedToArray, extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import { useState, useEffect } from 'react';
import useDebounceFn from '../../../../node_modules/ahooks/es/useDebounceFn/index.js';
import SvgMagnifier from '../../../icons/legacy/magnifier.svg.js';
import { searchInputContainer } from './styles.js';
import Input from './Input.js';
import { createElement as jsx } from '../../../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js';

var _excluded = ["id", "placeholder", "delayBeforeSearch", "resetInput", "autoFocus", "disabled", "onInputChanged"];
var SearchInput = function SearchInput(_ref) {
  var id = _ref.id,
    placeholder = _ref.placeholder,
    _ref$delayBeforeSearc = _ref.delayBeforeSearch,
    delayBeforeSearch = _ref$delayBeforeSearc === void 0 ? 500 : _ref$delayBeforeSearc,
    _ref$resetInput = _ref.resetInput,
    resetInput = _ref$resetInput === void 0 ? false : _ref$resetInput,
    _ref$autoFocus = _ref.autoFocus,
    autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    onInputChanged = _ref.onInputChanged,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    searchValue = _useState2[0],
    setSearchValue = _useState2[1];
  var _useDebounceFn = useDebounceFn(function (value) {
      onInputChanged(value);
    }, {
      wait: delayBeforeSearch
    }),
    run = _useDebounceFn.run;
  var handleInputChange = function handleInputChange(e) {
    var value = e.target.value;
    setSearchValue(value);
    run(value);
  };
  useEffect(function () {
    if (resetInput) clearSearch();
  }, [resetInput]);
  var clearSearch = function clearSearch(e) {
    if (e) {
      e.stopPropagation();
    }
    onInputChanged("");
    setSearchValue("");
  };
  return jsx("div", _extends({
    css: searchInputContainer
  }, rest), jsx(Input, {
    id: id,
    placeholder: placeholder,
    value: searchValue,
    onChange: handleInputChange,
    autoComplete: "off",
    iconAfter: SvgMagnifier,
    showVerticalLine: false,
    isClearable: true,
    autoFocus: autoFocus,
    onClear: function onClear(e) {
      return clearSearch(e);
    },
    disabled: disabled
  }));
};

export { SearchInput as default };
//# sourceMappingURL=SearchInput.js.map
